<template>
    <Accordion v-model:activeIndex="activeTab">
        <AccordionTab>

            <template #header>
                <div class="flex justify-content-between w-full">
                    <div class="flex mt-2">
                        Linked tasks
                        <Badge
                            :value="linkedTasksCounter"
                            class="ml-2"
                        />
                    </div>
                    <div class="flex justify-content-end">
                        <Button
                            icon="pi pi-plus"
                            class="p-button-rounded mr-1"
                            @click="addLinkedTask"
                            v-tooltip="'Add linked Task'"
                        />
                    </div>
                </div>
            </template>

            <DataTable
                :value="selectedTasksData"
                stripedRows
                paginator
                :rows="5"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                :loading="loadingSelectedTasks"
            >
                <Column field="id" header="Id"></Column>
                <Column field="taskCreatedDate" header="Date" style="width: 12rem"></Column>
                <Column field="title" header="Title"></Column>
                <Column field="description" header="Description"></Column>
                <Column field="priority" header="Priority" style="width: 10rem">
                    <template #body="slotProps">

                        <span v-if="slotProps.data?.priority?.status?.toLowerCase() === 'noprogress'"
                              class="status-badge status-noprogress">No Progress</span>
                        <span v-else-if="slotProps.data?.priority?.status?.toLowerCase() === 'completed'"
                              class="status-badge status-completed">Completed</span>
                        <span v-else-if="slotProps.data?.priority?.status?.toLowerCase() === 'inprogress'"
                              class="status-badge status-inprogress">In Progress</span>
                    </template>
                </Column>
                <Column field="progress" header="Progress" style="width: 9rem">

                    <template #body="slotProps">
                        <span v-if="slotProps.data?.progress?.status?.toLowerCase() === 'high'"
                              class="priority-badge status-high">High</span>
                        <span v-else-if="slotProps.data?.progress?.status?.toLowerCase() === 'medium'"
                              class="priority-badge status-medium">Medium</span>
                        <span v-else-if="slotProps.data?.progress?.status?.toLowerCase() === 'low'"
                              class="priority-badge status-low">Low</span>
                    </template>

                </Column>
                <Column field="actions" header="ACTIONS"  style="width: 4rem">
                    <template #body="slotProps">
                        <span class="p-column-title">Action</span>
                        <Button
                            icon="pi pi-trash"
                            class="p-button-rounded p-button-danger"
                            v-tooltip="'Remove linked Task'"
                            @click="removeLinkedTask(slotProps.data.id)"
                        />
                    </template>
                </Column>
            </DataTable>

        </AccordionTab>
    </Accordion>

    <Dialog v-model:visible="showDialog" header="Select Tasks" :style="{ width: '90rem' }" @hide="showDialog = false" modal>
        <div class="p-fluid formgrid grid flex flex-wrap">
            <div class="field col-12 sm:col-6 md:col-3">
                <label class="mb-2" for="task_title">Task Title</label>
                <InputText id="task_title" v-model="filter.taskName" placeholder="Enter Task title" />
            </div>
            <div class="field col-12 sm:col-6 md:col-3">
                <base-dropdown v-model="filter.progress" :options="progressItems" optionLabel="name" optionValue="id" label="Status" :filter="false" />
            </div>
            <div class="field col-12 sm:col-6 md:col-3">
                <base-dropdown v-model="filter.priority" :options="priorityItems" optionLabel="name" optionValue="id" label="Priority" :filter="false" />
            </div>
            <div class="field col-12 sm:col-6 md:col-3" />

            <div class="field col-12 sm:col-6 md:col-3">
                <base-calendar-input v-model="filter.start_date_from" label="Start Date From" dateFormat="dd-mm-yy" />
            </div>
            <div class="field col-12 sm:col-6 md:col-3">
                <base-calendar-input v-model="filter.start_date_to" label="Start Date To" dateFormat="dd-mm-yy" />
            </div>
            <div class="field col-12 sm:col-6 md:col-3">
                <base-calendar-input v-model="filter.due_date_from" label="Due Date From" dateFormat="dd-mm-yy" />
            </div>
            <div class="field col-12 sm:col-6 md:col-3">
                <base-calendar-input v-model="filter.due_date_to" label="Due Date To" dateFormat="dd-mm-yy" />
            </div>

            <div class="col-12 flex align-content-center justify-content-center	">
                <div class="field flex">
                    <Button icon="pi pi-filter" label="Filter" @click="applyFilters" class="mr-2" v-tooltip="'Apply filters'"/>
                    <Button icon="pi pi-filter-slash" severity="warning" label="Filter" @click="clearFilters" v-tooltip="'Clear all filters'"  />
                </div>
            </div>
        </div>

        <div>

            <DataTable
                v-model:first="offsetTaskList"
                :value="taskList"
                stripedRows
                :rows="numberOfRowsTaskList"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                :loading="taskListLoading"

                :lazy="true"
                :totalRecords="totalRecords"
                @page="onTaskPage($event)"
                :paginator="true"

                paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
            >
            <Column field="id" header="Id"></Column>
            <Column field="taskCreatedDate" header="Date" style="width: 12rem"></Column>
            <Column field="title" header="Title"></Column>
            <Column field="description" header="Description"></Column>
            <Column field="priority" header="Priority" style="width: 10rem">
                <template #body="slotProps">

                    <span v-if="slotProps.data?.priority?.status?.toLowerCase() === 'noprogress'"
                          class="status-badge status-noprogress">No Progress</span>
                    <span v-else-if="slotProps.data?.priority?.status?.toLowerCase() === 'completed'"
                          class="status-badge status-completed">Completed</span>
                    <span v-else-if="slotProps.data?.priority?.status?.toLowerCase() === 'inprogress'"
                          class="status-badge status-inprogress">In Progress</span>
                    <span v-else>
                        {{slotProps.data?.priority?.status}}
                    </span>
                </template>
            </Column>
            <Column field="progress" header="Progress" style="width: 9rem">

                <template #body="slotProps">
                        <span v-if="slotProps.data?.progress?.status?.toLowerCase() === 'high'"
                              class="priority-badge status-high">High</span>
                    <span v-else-if="slotProps.data?.progress?.status?.toLowerCase() === 'medium'"
                          class="priority-badge status-medium">Medium</span>
                    <span v-else-if="slotProps.data?.progress?.status?.toLowerCase() === 'low'"
                          class="priority-badge status-low">Low</span>
                </template>

            </Column>
            <Column field="actions" header="Actions"  style="width: 4rem">
                <template #body="slotProps">

                    <div v-if="currentTaskId === slotProps.data.id" v-tooltip="'Current Task'">
                        <Button
                            icon="pi pi-arrow-right-arrow-left"
                            rounded
                            severity="info"
                            disabled
                        />
                    </div>
                    <div v-else-if="isAlreadyLinked(slotProps.data.id) === true" v-tooltip="'Already linked Task'">
                        <Button
                            icon="pi pi-check"
                            rounded
                            severity="info"
                            disabled
                        />
                    </div>
                    <Button
                        v-else
                        icon="pi pi-link"
                        rounded
                        severity="info"
                        v-tooltip="'Link this Task'"
                        @click="linkTask(slotProps.data)"
                    />

                </template>
            </Column>
            </DataTable>

        </div>
    </Dialog>

</template>

<script setup>

import { computed, defineEmits, defineProps, onMounted, ref } from 'vue';
import { authApi } from '@/utilities/axios';
import { authStore } from '@/store/global-stores';
import { showToast } from '@/utilities/toast-handler';
import { DateTime } from 'luxon';
import { getAllPriorities, getAllProgress } from '@/product/ams/constants';

const props = defineProps({
    selectedTasks: {
        type: Array,
    },
    currentTaskId: {
        type: Number,
    }
});

const emit = defineEmits(['linkedTaskUpdate']);

const loadingSelectedTasks = ref(false)
const selectedTasksData = ref([])
const activeTab = ref([])
const showDialog = ref(false)

const progressItems = ref(null);
const priorityItems = ref(null);
const currentTaskListPage = ref(0)
const taskList = ref([])
const taskListLoading = ref(false)
const totalRecords = ref(0)
const numberOfRowsTaskList = ref(5)

const filter = ref({
    taskName: null,
    start_date_from: null,
    start_date_to: null,
    due_date_from: null,
    due_date_to: null,
    priority: null,
    progress: null,
})

const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

const linkedTasksCounter = computed(() => {
    if (typeof props.selectedTasks === 'undefined' || props.selectedTasks === null) {
        return '0';
    } else {
        return props.selectedTasks.length.toString()
    }
});

/**
 * Warning! this component could be mounted twice: one with selectedTasks equal to null and another one when the
 * selectedTasks became an array.
 */
onMounted(() => {
    progressItems.value = getAllProgress();
    priorityItems.value = getAllPriorities();

    if (props.selectedTasks && props.selectedTasks.length > 0) {
        // It's useless to call it if there isn't any selected tasks.
        loadSelectedTasks(props.selectedTasks)
    }
})

function clearFilters() {
    filter.value = {
        taskName: null,
        start_date_from: null,
        start_date_to: null,
        due_date_from: null,
        due_date_to: null,
        priority: null,
        progress: null,
    }
    numberOfRowsTaskList.value = 5
    currentTaskListPage.value = 0

    loadAllTasks()
}

const offsetTaskList = computed(() => {
    return numberOfRowsTaskList.value * currentTaskListPage.value
})

function applyFilters() {
    currentTaskListPage.value = 0

    loadAllTasks()
}

function isAlreadyLinked(taskId) {
    const found = selectedTasksData.value.find((item) => {
        return item.id === taskId;
    })

    return !(typeof found === 'undefined' || found === null);
}

function onTaskPage(event) {
    currentTaskListPage.value = event.page
    numberOfRowsTaskList.value = event.rows

    loadAllTasks()
}

function loadAllTasks() {
    taskListLoading.value = true
    taskList.value = []

    let params = {
        company_id: company_id.value,
        page: currentTaskListPage.value + 1,
        page_size: numberOfRowsTaskList.value,
        sort: "id desc"
    }

    if (filter.value.taskName) {
        params.title = filter.value.taskName
    }
    if (filter.value.progress) {
        params.progress = filter.value.progress
    }
    if (filter.value.priority) {
        params.priority = filter.value.priority
    }
    if (filter.value.due_date_from) {
        params.due_date_from = filter.value.due_date_from
    }
    if (filter.value.due_date_to) {
        params.due_date_to = filter.value.due_date_to
    }
    if (filter.value.start_date_from) {
        params.start_date_from = filter.value.start_date_from
    }
    if (filter.value.start_date_to) {
        params.start_date_to = filter.value.start_date_to
    }

    authApi.get('/v2/tasks', {
        params: params,
    }).then((response) => {
        if (typeof response !== 'undefined' && response.statusCode === 200 && response.data) {
            totalRecords.value = response.data.total

            response.data.data.forEach(item => {
                taskList.value.push(parseTaskData(item))
            })

            taskListLoading.value = false
        } else {
            console.error('response', response)
            console.error('response.statusCode', response.statusCode)
        }
    })
}

function addLinkedTask() {
    loadAllTasks(0)

    activeTab.value = [0]

    showDialog.value = true
}

function loadSelectedTasks(taskIds) {
    loadingSelectedTasks.value = true

    selectedTasksData.value = []
    loadSelectedTasksPaginated(taskIds, 1)
}

function loadSelectedTasksPaginated(taskIds, page) {
    // just be sure that it is an int.
    page = parseInt(page)

    loadingSelectedTasks.value = true

    let params = {
        company_id: company_id.value,
        tasks: taskIds,
        page: page,
        page_size: 10,
    }

    if (taskIds !== null && typeof taskIds !== 'undefined' && taskIds.length > 0) {
        authApi.get('/v2/tasks', {
            params: params,
        }).then((response) => {
            if (typeof response !== 'undefined' && response.statusCode === 200 && response.data) {
                const lastPage = parseInt(response.data.last_page)

                /*
                If there are more pages to load, re-run loadSelectedTasksPaginated for all of them
                 */
                if (page === 1 && page < lastPage) {
                    for (let p = page+1; p <= lastPage; p++) {
                        loadSelectedTasksPaginated(taskIds, p)
                    }
                }

                if (page >= lastPage) {
                    // procedure terminated
                    loadingSelectedTasks.value = false
                }

                response.data.data.forEach(item => {
                    selectedTasksData.value.push(parseTaskData(item))
                })
            }


        }).catch((error) => {
            showToast({}, error?.data?.message ?? 'Failed to fetch selected tasks');
        })
    }
}

function linkTask(taskData) {
    selectedTasksData.value.push(taskData)

    let output = []
    selectedTasksData.value.forEach((item) => {
        output.push(item.id)
    })

    emit('linkedTaskUpdate', output)
}

function parseTaskData(task) {
    let description = stripTags(task.description)
    let title = stripTags(task.title)

    const maxLen = 180

    if (description.length > maxLen) {
        description = description.substring(0,maxLen-5) + '[...]'
    }

    if (title.length > maxLen) {
        title = title.substring(0,maxLen-5) + '[...]'
    }

    const taskCreatedDate = DateTime.fromISO(task.created_at).toLocaleString(
        {
            weekday: 'short',
            month: 'short',
            day: '2-digit',
            year: 'numeric',
        })

    return {
        id: task.id,
        title: title,
        description: description,
        taskCreatedDate: taskCreatedDate,
        priority: progressItems.value.find((status) => status.id.toString() === task.progress),
        progress: priorityItems.value.find((priority) => priority.id.toString() === task.priority),
    }
}

function removeLinkedTask(taskId) {
    selectedTasksData.value = selectedTasksData.value.filter(function (item) {
        return item.id !== taskId
    });

    let output = []
    selectedTasksData.value.forEach((item) => {
        output.push(item.id)
    })

    emit('linkedTaskUpdate', output)
}

function stripTags(str) {
    if (str !== null && typeof str !== 'undefined') {
        return str.replace(/<[^>]*>/g, '').replace(/\t/g,'')
    } else {
        return ''
    }
}

</script>

<style scoped>

.status-badge {
    border-radius: var(--border-radius);
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-noprogress {
        background: #ffcdd2;
        color: #c63737;
    }
    &.status-inprogress {
        background: #feedaf;
        color: #8a5340;
    }
    &.status-completed {
        background: #c8e6c9;
        color: #256029;
    }
}

.priority-badge {
    border-radius: var(--border-radius);
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-low {
        background: #b3e5fc;
        color: #23547b;
    }

    &.status-medium {
        background: #feedaf;
        color: #8a5340;
    }
    &.status-high {
        background: #ffcdd2;
        color: #c63737;
    }
}
</style>